/** Normalize Laravel paginator or plain array from API responses. */
export function parseApiList(result) {
    if (result?.status !== 200) return [];
    const payload = result.data?.data;
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    return [];
}

export function parseApiPagination(result) {
    if (result?.status !== 200) {
        return { rows: [], lastPage: 1 };
    }
    const payload = result.data?.data;
    if (Array.isArray(payload)) {
        return { rows: payload, lastPage: 1 };
    }
    return {
        rows: Array.isArray(payload?.data) ? payload.data : [],
        lastPage: payload?.last_page || 1,
    };
}
